import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from 'reactstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
  getContent,
  updateContent,
} from 'features/contents/contentsAPI';
import { useAlertError } from 'hooks';
import AlertError from 'components/AlertError';
import { getErrorMessage } from 'utils/errors';
import { Link } from 'react-router-dom';

const quillModules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean'],
  ],
};

export default function IOMAModules() {
  const [content, setContent] = useState('');
  const [saving, setSaving] = useState(false);

  const [showError, messageError, detailsError, callbackError, alert] =
    useAlertError();

  useEffect(() => {
    getContent('ioma_modules')
      .then(result => {
        if (result) {
          setContent(result.content);
        }
      })
      .catch(err => {
        console.error(err);
        alert(
          'No se pudo recuperar los módulos. ' +
          'Por favor, intente nuevamente más tarde',
          getErrorMessage(err),
        );
      });
  }, []);

  const handleSave = () => {
    setSaving(true);
    updateContent('ioma_modules', content)
      .then(result => {
        setSaving(false);
        if (!result) {
          alert(
            'No se pudo guardar los módulos. ' +
            'Por favor, intente nuevamente más tarde',
          );
        }
      })
      .catch(err => {
        setSaving(false);
        console.error(err);
        alert(
          'No se pudo guardar los módulos. ' +
          'Por favor, intente nuevamente más tarde',
          getErrorMessage(err),
        );
      });
  };

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
          </div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col md='8'>
                    <h3 className="mb-0">
                      Desc. Módulos de Prestación de IOMA
                    </h3>
                  </Col>
                  <Col md='4' className='text-right'>
                    <Button
                      color='primary'
                      className='btn btn-md'
                      onClick={handleSave}
                      disabled={saving}
                    >
                      {saving ? 'Guardando...' : 'Guardar'}
                    </Button>
                    <Link to="/admin/contenidos">
                      <Button
                        color='secondary'
                        className='btn btn-md'
                      >
                        Volver
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <ReactQuill
                  theme="snow"
                  value={content}
                  onChange={setContent}
                  modules={quillModules}
                  style={{ minHeight: '400px' }}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <AlertError
        isOpen={showError}
        message={messageError}
        details={detailsError}
        onClose={callbackError}
      />
    </>
  );
}
